import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.QuotePricingmodelAdjustmentDialog.';

  public static readonly levelAdjustmentTitle = `${Id.prefix}levelAdjustmentTitle`;
}

export class LangQuotePricingmodelAdjustmentDialog {
  private constructor() {}

  public static levelAdjustmentTitle(params: { calculationLabel: string }): string {
    return interpolate(Id.levelAdjustmentTitle, params);
  }
}

export class QuotePricingmodelAdjustmentDialogModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.levelAdjustmentTitle,
      "{{glossary 'franchisee'}} {{glossary 'quote'}} Level {{calculationLabel}} Adjustment",
      'Title for the pricing model adjustment dialog, using glossary terms and calculation label'
    );
  }
}
